/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const Q_scared = require('./Q_scared');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const Q_stunned = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  // branch indexes
  node.BLUNT_ARROW = 2;
  node.BASH = 3;

  node.branches[node.YES] = new Q_scared(actor, battleState);

  if (BattleCalc.getEquippedAbility(actor, 'blunt_arrow')) {
    node.branches[node.BLUNT_ARROW] = new UseAbility({
      actor,
      abilityHandle: 'blunt_arrow',
      altNode: node.branches[node.YES],
    });
  } else {
    node.branches[node.BLUNT_ARROW] = node.branches[node.YES];
  }

  if (BattleCalc.getEquippedAbility(actor, 'bash')) {
    node.branches[node.BASH] = new UseAbility({
      actor,
      abilityHandle: 'bash',
      altNode: node.branches[node.YES],
    });
  } else {
    node.branches[node.BASH] = node.branches[node.BLUNT_ARROW];
  }

  node.query = function (target) {
    if (!target) {
      return null;
    }

    if (this.yesNoEvalFunction(target)) {
      return this.branches[this.YES].query(target);
    } else if (!BattleCalc.adjacent(this.actor, target)) {
      return this.branches[this.BLUNT_ARROW].query(target);
    } else {
      return this.branches[this.BASH].query(target);
    }
  };

  node.yesNoEvalFunction = function (target) {
    return (
      BattleCalc.getCondition(target, 'stunned') ||
      BattleCalc.getCondition(target, 'liberated') ||
      BattleCalc.getCondition(target, 'scared') // don't stun a feared target
    );
  };

  return node;
};
module.exports = Q_stunned;
